(() => {
    document.addEventListener('Store_PhoneSaleButton_Clicked', (event) => {
        window.dataLayerPushDeferred({
            event: 'clic_tel',
            event_type: 'tienda_' + event.detail.storeCode.toLocaleLowerCase('es-ES'),
        });
    });
})();
